import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import toast from 'react-hot-toast'
import { PnsMacMiniStatus } from 'interfaces/pns-mac-mini'

interface UpdateMacMiniStatusParams {
  macMiniId: string
  status: PnsMacMiniStatus
}

const updateMacMiniStatus = async ({
  macMiniId,
  status,
}: UpdateMacMiniStatusParams) => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/mac_minis/${macMiniId}`,
    {
      method: API_METHODS.PUT,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify({ status }),
    }
  )
  response = handleErrors(response)
  return response.json()
}

const useUpdateMacMiniStatus = () => {
  const queryClient = useQueryClient()

  return useMutation(updateMacMiniStatus, {
    onError: (error: Error) => {
      console.error('Failed to update Mac Mini status:', error)
      toast.error(`Failed to update Mac Mini status: ${error.message}`)
    },
    onSuccess: (data, variables) => {
      toast.success('Mac Mini status updated successfully')

      // Invalidate related queries
      queryClient.invalidateQueries(['mac-mini-detail', variables.macMiniId])
      queryClient.invalidateQueries(['mac-minis-by-ansible'])
      queryClient.invalidateQueries(['received-mac-minis'])
      queryClient.invalidateQueries(['ansible-detail'])
    },
  })
}

export default useUpdateMacMiniStatus
